// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';

// Utils
import { getShowDueDate } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getSelectedTaskIdSelector, getSelectedTaskSelector } from '../../../selector/selectionToolsSelector';

// Actions
import { toggleElementShowDueDatePill } from '../../../../../element/task/pills/assignment/dueDate/taskDueDateActions';

// Components
import Icon from '../../../../../components/icons/Icon';
import ToolbarTool from '../../ToolbarTool';
import { useToolbarItemTranslation } from '../../../hooks/useToolbarItemTranslation';

const isShowingDueDateSelector = createSelector(getSelectedTaskSelector, getShowDueDate);

const mapStateToProps = createStructuredSelector({
    selectedTaskId: getSelectedTaskIdSelector,
    isShowingDueDate: isShowingDueDateSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchToggleShowDueDate: (id) => dispatch(toggleElementShowDueDatePill({ id })),
});

const DueDateTool = (props) => {
    const { isShowingDueDate, dispatchToggleShowDueDate, selectedTaskId, item, name } = props;

    const onToggle = React.useCallback(() => {
        dispatchToggleShowDueDate(selectedTaskId);
    }, [selectedTaskId]);

    const { toolName } = useToolbarItemTranslation(item || {}, name);

    return (
        <div className="AssignUserTool">
            <ToolbarTool {...props} onClick={onToggle} name={toolName} isActive={isShowingDueDate}>
                <Icon name="toolbar-due-date" />
            </ToolbarTool>
        </div>
    );
};

DueDateTool.propTypes = {
    selectedTaskId: PropTypes.string,
    isShowingDueDate: PropTypes.bool,
    dispatchToggleShowDueDate: PropTypes.func,
    item: PropTypes.object,
    name: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(DueDateTool);
